import { css } from '@emotion/react';
import { gray7, gray4, gray2 } from 'styles/global_defaults/colors';

import NvIcon from 'shared/components/nv-icon';

import { TIME_SLOT_COLUMN_HEIGHT } from './availability-calendar-grid';

const styles = css`
  max-height: ${TIME_SLOT_COLUMN_HEIGHT}px;
  background-color: ${gray7};
  @keyframes shineAnimation {
    0% {
      color: ${gray4};
    }

    50% {
      color: ${gray2};
    }

    100% {
      color: ${gray4};
    }
  }
  .loading-time-slot {
    color: ${gray4};
    background-color: transparent;
    animation: shineAnimation 1.5s infinite;
  }
`;

const LoadingTimeSlot = () => (
  <div
    css={styles}
    className='loading-slots w-100 h-100 d-flex justify-content-center align-items-center'
  >
    <NvIcon icon='more' size='small' className='loading-time-slot' />
  </div>
);

export default LoadingTimeSlot;
